import "../../style.css"
import "./style.css"
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from "react-i18next";
import {
  fetchAccountInfo,
  updateIndividualDetail,
  changeEmailCheckPassword,
  resendEmailVerification
} from "../../../../../actions/profile";
import ModalEditInfo from "./_components/ModalEditInfo";
import { ModalButton, ModalButtonRow } from "../../../../../components/modal/ModalButtons";
import InputForm from "../../../../../components/input/input-register/InputForm";
import SelectForm from "../../../../../components/input/input-register/SelectForm";
import PhoneNumberForm from "../../../../../components/input/input-register/PhoneNumberForm";
import { optionsPronounce, findPronounceOption } from "../../../../../utils/dataLists";
import { getLocationByAddress } from "../../../../../actions/googleAPI";
import ModalConfirmation from "./_components/ModalConfirmation";
import ModalSuccessEdit from "./_components/ModalSuccessEdit";
import { useLoading } from "../../../../../components/LoadingContext";
import FlywireModalTokenization from "../../../../../components/modal/FlywireModalTokenization";
import { translate } from "../../../../../actions/googleAPI";
import ModalSuccessChangeEmail from "./_components/ModalSuccessChangeEmail";
import ModalSuccessChangePassword from "./_components/ModalSuccessChangePassword";
import SkeletonLoading from "./_components/SkeletonLoading";
import { DeleteIcon, LogoutIcon } from "../../../../../components/icons";

const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/visa.svg";
const master_card_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/master-card.svg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/jcb.svg";
const american_ex_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/american_ex.svg";

const BussinessAccountInformation = ({
  state = {
    modal: "",
    newEmail: ""
  }
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { showLoading, closeLoading } = useLoading();
  const [isLoading, setIsLoading] = useState(true);
  const [individualDetail, setIndividualDetail] = useState({
    billingInformation: {},
    paymentMethod: [],
  });
  const [accountDetail, setAccountDetail] = useState({
    changeEmailVerificationStatus: true,
    name: "",
    email: "",
    newEmail: "",
  })
  const [editIndividualDetail, setEditIndividualDetail] = useState({
    billingInformation: {},
    paymentMethod: [],
  })
  const [openModalEdit, setOpenModalEdit] = useState(null);
  const [isPostalCodeDisabled, setIsPostalCodeDisabled] = useState(false);
  const [isCityDisabled, setIsCityDisabled] = useState(false);
  const [errorEditIndividualDetail, setErrorEditIndividualDetail] = useState({
    billingPostalCode: null,
    billingName: null,
    billingPhoneNumber: null,
    billingAddress: null,
  })
  const [modalConfirm, setModalConfirm] = useState({
    text: "Are You Sure What to edit?",
    cancel: "Cancel",
    proceed: "Update",
    handleClose: () => { },
    handleContinue: () => { },
    show: false,
  })
  const [modalSuccessEdit, setModalSuccessEdit] = useState({
    text: "Your Account Has Been Successfully Updated!",
    handleClose: () => { },
    show: false,
  })
  const [passwordChangeEmail, setPasswordChangeEmail] = useState("");
  const [passwordChangeEmailError, setPasswordChangeEmailError] = useState("");
  const [isResendingEmail, setIsResendingEmail] = useState(false);
  const [isSuccessResendEmail, setIsSuccessResendEmail] = useState(false);

  // const showModalState = "changePassword";
  const showModalState = state?.modal || "";

  const reFetchData = async () => {
    const data = await fetchAccountInfo();

    setIndividualDetail({
      billingInformation: data.individualDetail.billingInformation,
      paymentMethod: data.individualDetail.paymentMethod,
    })
    setEditIndividualDetail({
      billingInformation: data.individualDetail.billingInformation,
      paymentMethod: data.individualDetail.paymentMethod,
    })
    setAccountDetail({
      changeEmailVerificationStatus: data.changeEmailVerificationStatus,
      name: data.name,
      email: data.email,
      newEmail: data.newEmail
    })
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const data = await fetchAccountInfo();

      setIndividualDetail({
        billingInformation: data.individualDetail.billingInformation,
        paymentMethod: data.individualDetail.paymentMethod,
      })
      setEditIndividualDetail({
        billingInformation: data.individualDetail.billingInformation,
        paymentMethod: data.individualDetail.paymentMethod,
      })
      setAccountDetail({
        changeEmailVerificationStatus: data.changeEmailVerificationStatus,
        name: data.name,
        email: data.email,
        newEmail: data.newEmail,
      })
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handleEditIndividualDetail = async (bodyRequest) => {
    showLoading(true);
    const updateDetail = await updateIndividualDetail(bodyRequest);

    if (updateDetail.code === 200) {
      setOpenModalEdit(null);
      setModalConfirm({
        text: "",
        cancel: "Cancel",
        proceed: "Update",
        handleClose: () => { },
        handleContinue: () => { },
        show: false,
      })
      reFetchData();
      setModalSuccessEdit({
        text: "Your Account Has Been Successfully Updated!",
        status: "success",
        handleClose: () => {
          setModalSuccessEdit({
            ...modalSuccessEdit,
            show: false,
          })
        },
        show: true,
      })
      closeLoading(true);
    } else {
      setModalSuccessEdit({
        text: "Failed to update your account. Please try again later.",
        status: "error",
        handleClose: () => {
          setModalSuccessEdit({
            ...modalSuccessEdit,
            show: false,
          })
        },
        show: true,
      })
      closeLoading(true);
    }
  }

  const handleEditButton = async (sectionName) => {
    // Validate billing information before submitting
    if (sectionName === "billingInformation") {
      const errors = {};

      // Validate billing name (not empty and minimum 3 characters)
      if (!editIndividualDetail?.billingInformation?.name || editIndividualDetail.billingInformation.name.trim() === "") {
        errors.billingName = "businessRegister.validation.billingName";
      } else if (editIndividualDetail.billingInformation.name.trim().length < 3) {
        errors.billingName = "businessRegister.validation.billingNameMinLength";
      }

      // Validate phone number (not empty)
      if (!editIndividualDetail?.billingInformation?.phone || editIndividualDetail.billingInformation.phone.trim() === "") {
        errors.billingPhoneNumber = "businessRegister.validation.billingPhoneNumber";
      }

      // Validate address (not empty)
      if (!editIndividualDetail?.billingInformation?.address || editIndividualDetail.billingInformation.address.trim() === "") {
        errors.billingAddress = "businessRegister.validation.billingAddress";
      }

      // If there are errors, set them and return
      if (Object.keys(errors).length > 0) {
        setErrorEditIndividualDetail({ ...errorEditIndividualDetail, ...errors });
        return;
      }
    }

    setModalConfirm({
      text: "Are You Sure want to edit?",
      cancel: "Cancel",
      proceed: "Update",
      handleClose: () => {
        setModalConfirm({
          text: "",
          cancel: "Cancel",
          proceed: "Update",
          handleClose: () => { },
          handleContinue: () => { },
          show: false,
        })
      },
      handleContinue: () => { handleEditIndividualDetail(editIndividualDetail) },
      show: true,
    })
  }

  const extractFirstAndLastName = async (fullName) => {
    // Split the full name into an array of strings
    const nameParts = fullName.trim().split(" ");

    // Extract the first name (first element of the array)
    const firstName = nameParts[0];

    // Extract the last name (last element of the array, if exists)
    const lastName =
      nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";

    // Return an object containing the first name and last name
    return {
      firstName: firstName,
      lastName: lastName ? lastName : firstName,
    };
  };

  const openModalFlywire = async () => {
    showLoading(true);
    const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

    let city;
    let zipCode;
    if (countryWithoutPostCode.split(',').includes(individualDetail.billingInformation.country_code)) {
      city = individualDetail.billingInformation.city;
      zipCode = "-";
    } else {
      const zipCodeCheck = await getLocationByAddress(individualDetail.billingInformation.postal_code, individualDetail.billingInformation.country_code);
      if (zipCodeCheck.address_components.filter((item) => item.types.includes("administrative_area_level_2") || item.types.includes("locality")).length !== 0) {
        const cityComponent = zipCodeCheck.address_components.find(
          (item) =>
            item.types.includes("administrative_area_level_2") ||
            item.types.includes("locality")
        );

        city = cityComponent ? cityComponent.long_name : null;
      } else {
        city = zipCodeCheck.address_components[zipCodeCheck.address_components.length - 2].long_name;
      }

      zipCode = individualDetail.billingInformation.postal_code;
    }
    const { firstName, lastName } = await extractFirstAndLastName(individualDetail.billingInformation.name);

    const regex = /[\u4E00-\u9FFF\u3040-\u30FF\uFF66-\uFF9F]/
    const checkAddressContainsJapanese = regex.test(individualDetail.billingInformation.address);
    let finalAddress
    if (checkAddressContainsJapanese) {
      const translateResult = await translate("en", individualDetail.billingInformation.address)

      finalAddress = translateResult.translatedText.replace("〒", "");
    } else {
      finalAddress = individualDetail.billingInformation.address;
    }

    closeLoading(true);

    FlywireModalTokenization({
      firstName: firstName,
      lastName: lastName,
      email: accountDetail.email,
      phone: `${individualDetail.billingInformation.prefix_number} ${individualDetail.billingInformation.phone}`,
      address: finalAddress,
      city: city,
      zip: zipCode,
      country: individualDetail.billingInformation.country_code,
      successCallback: (result) => {
        const newPaymentMethod = {
          brand: result.brand,
          cardNumber: result.digits,
          digits: result.digits,
          expirationMonth: result.expirationMonth,
          expirationYear: result.expirationYear,
          paymentMethod: result.paymentMethod,
          mmyy: `${result.expirationMonth.padStart(2, "0")}${result.expirationYear.substr(-2)}`,
          token: result.token,
          type: result.type,
        };

        const bodyRequest = {
          ...editIndividualDetail,
          paymentMethod: [
            ...editIndividualDetail.paymentMethod,
            newPaymentMethod
          ]
        }

        handleEditIndividualDetail(bodyRequest);
      }
    });
  };

  function getCardType(brand) {
    if (brand === "VISA") {
      return visa_icon;
    } else if (brand === "MASTERCARD") {
      return master_card_icon;
    } else if (brand === "AMEX") {
      return american_ex_icon;
    } else if (brand === "JCB") {
      return jcb_icon;
    }

    return "Unknown"; // If none of the patterns match
  }

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("cart");
    window.location = "/";
  };

  // Logging out clears the session and leaves the page, so ask first instead
  // of logging out on the first click. Reuses the page's confirmation modal.
  const openLogoutConfirmation = () => {
    const closeLogoutConfirmation = () => {
      setModalConfirm((previousModalConfirm) => ({ ...previousModalConfirm, show: false }));
    };

    setModalConfirm({
      text: t("myPage.accountInformation.logoutConfirmation.title"),
      cancel: t("myPage.accountInformation.logoutConfirmation.cancel"),
      proceed: t("myPage.accountInformation.logoutConfirmation.proceed"),
      handleClose: closeLogoutConfirmation,
      handleContinue: handleLogout,
      confirmVariant: "danger",
      confirmIcon: <LogoutIcon color="#FFFFFF" size={18} />,
      show: true,
    });
  };

  const handleCloseModalEdit = () => {
    setEditIndividualDetail({
      ...individualDetail,
    });
    setOpenModalEdit(null)
    setPasswordChangeEmail("")
    setPasswordChangeEmailError("")
  }

  const handleChangeEditIndividualDetail = (e) => {
    const { name, value } = e.target;
    const keys = name.split('.');

    // Clear validation errors when user types
    if (name === "billingInformation.name" && errorEditIndividualDetail.billingName) {
      setErrorEditIndividualDetail({ ...errorEditIndividualDetail, billingName: null });
    }
    if (name === "billingInformation.phone" && errorEditIndividualDetail.billingPhoneNumber) {
      setErrorEditIndividualDetail({ ...errorEditIndividualDetail, billingPhoneNumber: null });
    }
    if (name === "billingInformation.address" && errorEditIndividualDetail.billingAddress) {
      setErrorEditIndividualDetail({ ...errorEditIndividualDetail, billingAddress: null });
    }

    if (keys.length === 1) {
      // Non-nested field
      setEditIndividualDetail(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setEditIndividualDetail(prev => {
        const updated = { ...prev };
        let temp = updated;

        for (let i = 0; i < keys.length - 1; i++) {
          temp[keys[i]] = { ...temp[keys[i]] };
          temp = temp[keys[i]];
        }

        temp[keys[keys.length - 1]] = value;
        return updated;
      });
    }
  };

  const handleChangeHonorifics = (name, e) => {
    const [sectionName, fieldName] = name.split(".");

    // Copy the section instead of writing into it: on load the edit copy and
    // the saved copy share the same nested objects, so writing in place also
    // changed the saved data (and the screen did not re-render).
    setEditIndividualDetail((previousDetail) => ({
      ...previousDetail,
      [sectionName]: {
        ...previousDetail[sectionName],
        [fieldName]: e?.value ?? "",
      },
    }));
  }

  const onClickCountryListBillingInformation = (dialCode, countryCode, countryName) => {
    const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

    if (!countryWithoutPostCode.split(',').includes(countryCode)) {
      setIsPostalCodeDisabled(false);
      setIsCityDisabled(true);
      setEditIndividualDetail({
        ...editIndividualDetail,
        billingInformation: {
          ...editIndividualDetail.billingInformation,
          postal_code: "",
          city: "",
          country_code: countryCode,
          prefix_number: dialCode,
          country: countryName
        }
      });
    } else {
      setEditIndividualDetail({
        ...editIndividualDetail,
        billingInformation: {
          ...editIndividualDetail.billingInformation,
          city: "",
          postal_code: "-",
          country_code: countryCode,
          prefix_number: dialCode,
          country: countryName
        }
      });
      setIsPostalCodeDisabled(true);
      setIsCityDisabled(false);
    }
  }

  const checkPostalCodeHandler = async () => {
    try {
      const zipCodeCheck = await getLocationByAddress(editIndividualDetail.billingInformation.postal_code, editIndividualDetail.billingInformation.country);

      if (zipCodeCheck) {
        let city
        if (zipCodeCheck.address_components.filter(item => item.types.includes("administrative_area_level_2") || item.types.includes("locality")).length !== 0) {
          city = zipCodeCheck.address_components.filter(item => item.types.includes("administrative_area_level_2") || item.types.includes("locality"))[0].long_name
        } else {
          city = zipCodeCheck.address_components[zipCodeCheck.address_components.length - 2].long_name
        }

        setErrorEditIndividualDetail({
          ...errorEditIndividualDetail,
          billingPostalCode: null
        });

        setEditIndividualDetail({
          ...editIndividualDetail,
          billingInformation: {
            ...editIndividualDetail.billingInformation,
            city: city
          }
        })
      } else {
        setErrorEditIndividualDetail({
          ...errorEditIndividualDetail,
          billingPostalCode: "businessRegister.validation.billingPostalCodeInvalid"
        });

        setEditIndividualDetail({
          ...editIndividualDetail,
          billingInformation: {
            ...editIndividualDetail.billingInformation,
            city: ""
          }
        })
      }
    } catch (e) {
      console.error(e);
    }
  }

  const handleChangeEmailButton = async () => {
    showLoading(true);
    const changeEmailCheckPasswordResponse = await changeEmailCheckPassword({
      email: accountDetail?.email,
      password: passwordChangeEmail,
      type: "email"
    });

    if (changeEmailCheckPasswordResponse.status === "SUCCESS" && changeEmailCheckPasswordResponse.code === 200) {
      closeLoading(true);
      history.push(changeEmailCheckPasswordResponse.link)
    } else {
      setPasswordChangeEmailError(changeEmailCheckPasswordResponse?.message)
      closeLoading(true);
    }
  }

  const handleChangePasswordButton = async () => {
    showLoading(true);
    const changePasswordCheckPasswordResponse = await changeEmailCheckPassword({
      email: accountDetail?.email,
      password: passwordChangeEmail,
      type: "password"
    })

    if (changePasswordCheckPasswordResponse.status === "SUCCESS" && changePasswordCheckPasswordResponse.code === 200) {
      closeLoading(true);
      history.push(changePasswordCheckPasswordResponse.link)
    } else {
      setPasswordChangeEmailError(changePasswordCheckPasswordResponse?.message)
      closeLoading(true);
    }
  }

  const handleResendEmailVerif = async () => {
    setIsResendingEmail(true)

    const resendEmailVerificationResponse = await resendEmailVerification({
      newEmail: state.newEmail
    })

    if (resendEmailVerificationResponse.desc === "SUCCESS" && resendEmailVerificationResponse.code === 200) {
      setIsResendingEmail(false);
      setIsSuccessResendEmail(true);
    } else {
      setIsResendingEmail(false);
    }

  }

  return (
    <div>
      {isLoading ? (
        <SkeletonLoading />
      ) : (
        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:my-2">
          <div className="tw:flex-1 tw:p-4 tw:px-6">
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:py-2">
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[83.3333%] tw:lg:flex-none">
                <p className="fw-400 tw:mb-0!">
                  {t("myPage.accountInformation.subMenu.email.title")}
                </p>
                <p className="fw-700 tw:mb-0!">
                  {accountDetail?.email}
                </p>
                {accountDetail?.changeEmailVerificationStatus === false && (
                  <div className="tw:mb-2">
                    <p
                      className="text-info-change-email tw:mb-0! tw:mt-2"
                      dangerouslySetInnerHTML={{
                        __html: t("myPage.accountInformation.subMenu.email.desc.verifyEmail.1", { newEmail: accountDetail?.newEmail })
                      }}
                    >
                    </p>
                    <p
                      className="text-info-change-email tw:mb-0!"
                      dangerouslySetInnerHTML={{
                        __html: t("myPage.accountInformation.subMenu.email.desc.verifyEmail.2")
                      }}
                    >
                    </p>
                  </div>
                )}
              </div>
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[16.6667%] tw:lg:flex-none tw:flex tw:items-center tw:justify-end">
                <button
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-change-email"
                  onClick={() => setOpenModalEdit("changeEmail")}
                  disabled={accountDetail?.changeEmailVerificationStatus === false}
                >
                  {t("myPage.accountInformation.subMenu.email.button")}
                </button>
              </div>
              <ModalEditInfo
                title={t("myPage.accountInformation.subMenu.email.modal.title")}
                modalSize={"modal"}
                show={openModalEdit === "changeEmail"}
                onClose={handleCloseModalEdit}
              >
                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:1rem] tw:gap-y-4 tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                    <InputForm
                      type={"password"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("myPage.accountInformation.subMenu.email.modal.label")}
                      placeholder={t("myPage.accountInformation.subMenu.email.modal.password")}
                      id={"passwordChangeEmail"}
                      name={"passwordChangeEmail"}
                      value={passwordChangeEmail}
                      onChange={(e) => {
                        setPasswordChangeEmailError("")
                        setPasswordChangeEmail(e.target.value)
                      }}
                      isInvalid={passwordChangeEmailError !== ""}
                      invalidMessage={t(passwordChangeEmailError)}
                    />
                  </div>
                </div>

                <ModalButtonRow className="tw:mt-6">
                  <ModalButton variant="secondary" onClick={handleCloseModalEdit}>
                    {t("myPage.accountInformation.modalEdit.cancel")}
                  </ModalButton>
                  <ModalButton variant="primary" onClick={() => { handleChangeEmailButton() }}>
                    {t("myPage.accountInformation.modalEdit.proceed")}
                  </ModalButton>
                </ModalButtonRow>
              </ModalEditInfo>
            </div>
          </div>
          <hr className="hr-grey-account tw:p-0 tw:m-0" />
          <div className="tw:flex-1 tw:p-4 tw:px-6">
            <h5 className="account-section-title tw:py-2">{t("myPage.accountInformation.subMenu.billingInformation.title")}</h5>
            <hr className="hr-grey-account" />
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-between">
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[83.3333%] tw:lg:flex-none">
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:lg:w-1/4 tw:lg:flex-none">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.billingInformation.field.contactName")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {individualDetail?.billingInformation?.name}
                    </p>
                  </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:lg:w-1/4 tw:lg:flex-none">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.billingInformation.field.phoneNumber")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {`(${individualDetail?.billingInformation?.prefix_number}) ${individualDetail?.billingInformation?.phone}`}
                    </p>
                  </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:lg:w-1/4 tw:lg:flex-none">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.billingInformation.field.country")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {individualDetail?.billingInformation?.country}
                    </p>
                  </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:lg:w-1/4 tw:lg:flex-none">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.billingInformation.field.postalCode")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {individualDetail?.billingInformation?.postal_code}
                    </p>
                  </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:lg:w-1/4 tw:lg:flex-none">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.billingInformation.field.city")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {individualDetail?.billingInformation?.city}
                    </p>
                  </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[41.6667%] tw:flex-none tw:lg:w-1/4 tw:lg:flex-none">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.billingInformation.field.address")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-[58.3333%] tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {individualDetail?.billingInformation?.address}
                    </p>
                  </div>
                </div>
              </div>
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[16.6667%] tw:lg:flex-none tw:flex tw:items-start tw:justify-end">
                <button
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-edit-account tw:px-2 tw:py-2 tw:mt-2 tw:lg:mt-0"
                  onClick={() => setOpenModalEdit("billingInformation")}
                >
                  {t("myPage.accountInformation.subMenu.billingInformation.button")}
                </button>
              </div>
              <ModalEditInfo
                title={t("businessRegister.billingInformation.title")}
                show={openModalEdit === "billingInformation"}
                onClose={handleCloseModalEdit}
              >
                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:1rem] tw:gap-y-4 tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/4 tw:flex-none tw:md:w-[16.6667%] tw:md:flex-none tw:lg:w-[16.6667%] tw:lg:flex-none">
                    <SelectForm
                      name={"billingInformation.pronounced"}
                      suffixClass={"mb-0 fs-14"}
                      isSearchable={false}
                      options={optionsPronounce}
                      defaultValue={optionsPronounce[0]}
                      value={findPronounceOption(editIndividualDetail?.billingInformation?.pronounced)}
                      onChange={(e) => handleChangeHonorifics("billingInformation.pronounced", e)}
                      label={t("businessRegister.authorizedRepresentativeContacts.form.honorifics")}
                      placeholder={t("businessRegister.authorizedRepresentativeContacts.form.honorifics")}

                    />
                  </div>

                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-3/4 tw:flex-none tw:md:w-[41.6667%] tw:md:flex-none tw:lg:w-[41.6667%] tw:lg:flex-none">
                    <InputForm
                      type={"text"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("businessRegister.billingInformation.form.name")}
                      placeholder={t("businessRegister.billingInformation.form.name")}
                      id={"billingName"}
                      name={"billingInformation.name"}
                      value={editIndividualDetail?.billingInformation?.name}
                      onChange={handleChangeEditIndividualDetail}
                      isInvalid={errorEditIndividualDetail.billingName}
                      invalidMessage={t(errorEditIndividualDetail.billingName)}
                    />
                  </div>

                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:md:w-[41.6667%] tw:md:flex-none tw:lg:w-[41.6667%] tw:lg:flex-none">
                    <PhoneNumberForm
                      id="billingPhoneNumber"
                      suffixClass={"mb-0 fs-14"}
                      name="billingInformation.phone"
                      label={t("businessRegister.billingInformation.form.phoneNumber")}
                      placeholder={t("businessRegister.billingInformation.form.phoneNumber")}
                      countryCode={editIndividualDetail?.billingInformation?.country_code}
                      prefixPhoneNumber={editIndividualDetail?.billingInformation?.prefix_number}
                      value={editIndividualDetail?.billingInformation?.phone}
                      onClickCountryList={onClickCountryListBillingInformation}
                      onChange={handleChangeEditIndividualDetail}
                      isInvalid={errorEditIndividualDetail.billingPhoneNumber}
                      invalidMessage={t(errorEditIndividualDetail.billingPhoneNumber)}
                    />
                  </div>
                </div>

                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:[--gx:1rem] tw:gap-y-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-1/3 tw:md:flex-none">
                    <InputForm
                      type={"text"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("businessRegister.billingInformation.form.country")}
                      placeholder={t("businessRegister.billingInformation.form.country")}
                      id={"billingCountry"}
                      name={"billingInformation.country"}
                      value={editIndividualDetail?.billingInformation?.country}
                      onChange={handleChangeEditIndividualDetail}
                      readOnly={true}
                      disable={true}
                    />
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-1/3 tw:md:flex-none">
                    <InputForm
                      type={"text"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("businessRegister.billingInformation.form.postalCode")}
                      placeholder={t("businessRegister.billingInformation.form.postalCode")}
                      id={"billingPostalCode"}
                      name={"billingInformation.postal_code"}
                      value={editIndividualDetail?.billingInformation?.postal_code}
                      onChange={handleChangeEditIndividualDetail}
                      onBlur={checkPostalCodeHandler}
                      disable={isPostalCodeDisabled}
                      readOnly={isPostalCodeDisabled}
                      isInvalid={errorEditIndividualDetail.billingPostalCode}
                      invalidMessage={t(errorEditIndividualDetail.billingPostalCode)}
                    />
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-1/3 tw:md:flex-none">
                    <InputForm
                      type={"text"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("businessRegister.billingInformation.form.city")}
                      placeholder={t("businessRegister.billingInformation.form.city")}
                      id={"billingCity"}
                      name={"billingInformation.city"}
                      value={editIndividualDetail?.billingInformation?.city}
                      onChange={handleChangeEditIndividualDetail}
                      isInvalid={errorEditIndividualDetail.billingCity}
                      invalidMessage={t(errorEditIndividualDetail.billingCity)}
                      readOnly={isCityDisabled}
                      disable={isCityDisabled}
                    />
                  </div>
                </div>

                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:[--gx:1rem] tw:gap-y-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow">
                    <InputForm
                      type={"text"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("businessRegister.billingInformation.form.address")}
                      placeholder={t("businessRegister.billingInformation.form.address")}
                      id={"billingAddress"}
                      name={"billingInformation.address"}
                      value={editIndividualDetail?.billingInformation?.address}
                      onChange={handleChangeEditIndividualDetail}
                      isInvalid={errorEditIndividualDetail.billingAddress}
                      invalidMessage={t(errorEditIndividualDetail.billingAddress)}
                    />
                  </div>
                </div>
                <ModalButtonRow className="tw:mt-6">
                  <ModalButton variant="secondary" onClick={handleCloseModalEdit}>
                    {t("myPage.accountInformation.modalEdit.cancel")}
                  </ModalButton>
                  <ModalButton variant="primary" onClick={() => { handleEditButton("billingInformation") }}>
                    {t("myPage.accountInformation.modalEdit.proceed")}
                  </ModalButton>
                </ModalButtonRow>
              </ModalEditInfo>
            </div>
          </div>
          <hr className="hr-grey-account tw:p-0 tw:m-0" />
          <div className="tw:flex-1 tw:p-4 tw:px-6">
            <h5 className="account-section-title tw:py-2">{t("myPage.accountInformation.subMenu.paymentMethod.title")}</h5>
            <hr className="hr-grey-account" />
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-between">
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[83.3333%] tw:lg:flex-none">
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-1/4 tw:lg:flex-none tw:mb-2 tw:lg:mb-0">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.paymentMethod.field.paymentMethod")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-3/4 tw:lg:flex-none">
                    <p className="account-text-value tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.paymentMethod.field.creditCards")}
                    </p>
                  </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-start tw:justify-start tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-1/4 tw:lg:flex-none tw:mb-2 tw:lg:mb-0">
                    <p className="account-text-label tw:mb-0!">
                      {t("myPage.accountInformation.subMenu.paymentMethod.field.cards")}
                    </p>
                  </div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-auto tw:lg:flex-none">
                    {
                      individualDetail.paymentMethod.map((v, i) => (
                        <div className="email-item" key={i}>
                          <img className="tw:pr-4" src={getCardType(v.brand)}></img>
                          <p className='account-text-value mb-0 pe-3'>{`••••${v.cardNumber}, ${t("myPage.accountInformation.subMenu.paymentMethod.field.exp")}: ${String(v.expirationMonth).padStart(2, '0')}/${String(v.expirationYear).slice(-2)}`}</p>
                          <button type="button" className="btn-remove">
                            <DeleteIcon />
                          </button>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[16.6667%] tw:lg:flex-none tw:flex tw:items-start tw:justify-end">
                <button
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-edit-account tw:px-2 tw:py-2 tw:mt-2 tw:lg:mt-0"
                  onClick={() => openModalFlywire()}
                >
                  {t("myPage.accountInformation.subMenu.paymentMethod.button")}
                </button>
              </div>
            </div>
          </div>
          <hr className="hr-grey-account tw:p-0 tw:m-0" />
          <div className="tw:flex-1 tw:p-4 tw:px-6">
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-center tw:justify-between">
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[83.3333%] tw:lg:flex-none">
                <p className="account-text-label tw:mb-0!">
                  {t("myPage.accountInformation.subMenu.password.title")}
                </p>
              </div>
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[16.6667%] tw:lg:flex-none tw:flex tw:items-start tw:justify-end">
                <button
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-edit-account tw:px-2 tw:py-2 tw:mt-2 tw:lg:mt-0"
                  onClick={() => setOpenModalEdit("changePassword")}
                >
                  {t("myPage.accountInformation.subMenu.password.button")}
                </button>
              </div>
              <ModalEditInfo
                title={t("myPage.accountInformation.subMenu.password.modal.title")}
                modalSize={"modal"}
                show={openModalEdit === "changePassword"}
                onClose={handleCloseModalEdit}
              >
                <div className="tw:flex tw:flex-wrap tw:mx-[calc(var(--gx)/-2)] tw:[--gx:1rem] tw:gap-y-4 tw:mb-4">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                    <InputForm
                      type={"password"}
                      suffixClass={"mb-0 fs-14"}
                      label={t("myPage.accountInformation.subMenu.password.modal.label")}
                      placeholder={t("myPage.accountInformation.subMenu.password.modal.password")}
                      id={"passwordChangeEmail"}
                      name={"passwordChangeEmail"}
                      value={passwordChangeEmail}
                      onChange={(e) => {
                        setPasswordChangeEmailError("")
                        setPasswordChangeEmail(e.target.value)
                      }}
                      isInvalid={passwordChangeEmailError !== ""}
                      invalidMessage={t(passwordChangeEmailError)}
                    />
                  </div>
                </div>

                <ModalButtonRow className="tw:mt-6">
                  <ModalButton variant="secondary" onClick={handleCloseModalEdit}>
                    {t("myPage.accountInformation.modalEdit.cancel")}
                  </ModalButton>
                  <ModalButton variant="primary" onClick={() => { handleChangePasswordButton() }}>
                    {t("myPage.accountInformation.modalEdit.proceed")}
                  </ModalButton>
                </ModalButtonRow>
              </ModalEditInfo>
            </div>
          </div>
          <hr className="hr-grey-account tw:p-0 tw:m-0" />
          <div className="tw:flex-1 tw:p-4 tw:px-6">
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-center tw:justify-center">
              <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:lg:w-[16.6667%] tw:lg:flex-none">
                <button
                  type="button"
                  className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-edit-account tw:px-2 tw:py-2 tw:mt-2 tw:lg:mt-0"
                  onClick={openLogoutConfirmation}
                >
                  {t("myPage.accountInformation.logout")}
                </button>
              </div>
            </div>
          </div>

          <ModalConfirmation
            text={modalConfirm.text}
            cancel={modalConfirm.cancel}
            proceed={modalConfirm.proceed}
            handleClose={modalConfirm.handleClose}
            handleContinue={modalConfirm.handleContinue}
            show={modalConfirm.show}
            confirmVariant={modalConfirm.confirmVariant}
            confirmIcon={modalConfirm.confirmIcon}
          />
          <ModalSuccessEdit
            text={modalSuccessEdit.text}
            handleClose={modalSuccessEdit.handleClose}
            show={modalSuccessEdit.show}
            status={modalSuccessEdit.status}
          />
          <ModalSuccessChangeEmail
            newEmail={state?.newEmail}
            handleClose={() => {
              history.replace('/my-page/account')
            }}
            handleClickButton={() => handleResendEmailVerif()}
            show={showModalState === "changeEmail"}
            isLoading={isResendingEmail}
            isSuccessResendEmail={isSuccessResendEmail}
          />
          <ModalSuccessChangePassword
            handleClose={() => {
              history.replace('/my-page/account')
            }}
            show={showModalState === "changePassword"}
          />
        </div>
      )}
    </div>
  );
};

export default BussinessAccountInformation;
